import { createQueryKeys } from '@lukemorales/query-key-factory'

import { categoryService } from '@/domain/Category'
import OldCategoryService from '@/services/Category/Category.service'

export const categories = createQueryKeys('categories', {
    listFeatured: () => ({
        queryKey: ['listFeatured'],
        queryFn: () => categoryService.getFeaturedCategories(),
    }),
    allParentsWithTree: () => ({
        queryKey: ['listWithTree'],
        queryFn: () => categoryService.getParentCategoriesWithDepth(),
    }),
    handle: (handle: string) => ({
        queryKey: ['handle', handle],
        queryFn: () => OldCategoryService.getCategoryByHandle(handle),
    }),
    handleGetProducts: (handle: string) => ({
        queryKey: ['handleGetProducts', handle],
        queryFn: () => OldCategoryService.getAllProductTemplates(handle),
    }),
    tree: (handle: string) => ({
        queryKey: ['tree', handle],
        queryFn: () => OldCategoryService.getCategoryTree(handle),
    }),
})
